/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {GroupChooserIcon} from '../../icons/GroupChooserIcon';
import Tooltip from '../tooltip/Tooltip';
import {IconButton} from './IconButton';

export const GroupChooserTooltip = function(props) {
  return <Tooltip arrow {...props} />;
};

// defines the container props ...
export type GroupChooserButtonProps = {
  onClick: (params?: boolean) => void
};

/**
 * The GroupChooserButton provides the Groupchooser Icon Button which shows account
 * change confirmation dialog
 *
 * ```typescript
 *   import {GroupChooserButton} from '@ion/dls/src/components/buttons/GroupChooserButton';
 *
 *   <GroupChooserButton onShowColumnChooser={onShowColumnChooser} />
 * ```
 */
export const GroupChooserButton = ({onClick}: GroupChooserButtonProps) => {
  return (
    <GroupChooserTooltip title={translate('common:groupChooser.title')}>
      <div>
        <IconButton style={{padding: '0px 12px 0px 0px'}} icon={<GroupChooserIcon />}
          onClick={onClick} />
      </div>
    </GroupChooserTooltip>
  );
};

export default GroupChooserButton;
